import { Button, Dialog, DialogActions, DialogContent } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { get, isEqual } from 'lodash';
import LoadingButton from '../../../../../components/LoadingButton';
import FormBuilderForm from './Form';
import {
  createFormBuilderAction,
  updateFormBuilderAction
} from '../../../../../reducers/formBuilder';
import { fetchOrganizationPricing } from '../../../../../reducers/organizationPricing';
import { clearGlobalPricing } from '../../../../../reducers/pricing';
import UpdateReasonForm from '../../../../../components/UpdateReasonForm';

const FormBuilderDialog = ({
  open,
  onClose,
  organization,
  formBuilder,
  layout,
  defaultControls,
  hiddenFields
}) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(null);

  useEffect(() => {
    setLoading(false);
  }, [formBuilder]);

  const onSubmit = reason => {
    setLoading(true);

    const data = {
      organization_id: get(organization, 'id', null),
      form_builder_id: get(formBuilder, 'id', null),
      form_data: [...formData],
      reason
    };

    if (organization && formBuilder.is_default) {
      dispatch(createFormBuilderAction(data)).then(() => {
        dispatch(fetchOrganizationPricing(organization.id));
      });
    } else {
      dispatch(updateFormBuilderAction(formBuilder.id, data)).then(() => {
        if (organization) {
          dispatch(fetchOrganizationPricing(organization.id));
        } else {
          dispatch(clearGlobalPricing());
        }
      });
    }
  };

  return (
    <>
      <Dialog fullWidth fullScreen open={open} onClose={e => e.preventDefault()}>
        <DialogContent id="form-builder-dialog">
          <FormBuilderForm
            formBuilder={formBuilder}
            hiddenFields={hiddenFields}
            layout={layout}
            defaultControls={defaultControls}
            onChange={setFormData}
          />
        </DialogContent>

        <DialogActions>
          <Button onClick={onClose}>Close</Button>
          <UpdateReasonForm>
            {({ open }) => (
              <LoadingButton
                type="submit"
                variant="contained"
                color="primary"
                disabled={isEqual(formData, layout)}
                loading={loading}
                onClick={() => open(reason => onSubmit(reason))}
              >
                Save Changes
              </LoadingButton>
            )}
          </UpdateReasonForm>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default FormBuilderDialog;
